

































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import WebhookInjectorMixin from "@/mixins/webhookInjectorMixin";

// Enums/Data
import { WebhookAdapterVersion } from "@/data/enums/webhooks";

// Types
import { IWebhook, IWebhookForm } from "@/models/webhooks";

@Component({
  components: {
    "webkook-add-edit-form": () =>
      import("@/components/app/admin/settings/webhooks/webkookAddEditForm.vue"),
    "webkook-triggers-comp": () =>
      import("@/components/app/admin/settings/webhooks/webhookTriggersComp.vue")
  }
})
export default class WebhookEditForm extends Mixins(
  HasValidation,
  WebhookInjectorMixin
) {
  // Props

  @Prop({ required: true })
  public webhookId!: IWebhook["id"];

  // Data

  public form: IWebhookForm = {
    description: "",
    enabled: true,
    name: "",
    secret: "",
    url: "",
    version: WebhookAdapterVersion.FIRST
  };
  public initialForm = {} as IWebhookForm;
  public isProcessing = false;

  // Life-cycle methods

  public created() {
    this.initiateForm();
  }

  // Methods

  public initiateForm() {
    this.form = _.merge(
      this.form,
      _.pick(this.$webhookData.webhook, [
        "description",
        "enabled",
        "name",
        "secret",
        "url"
      ])
    );
    this.initialForm = _.cloneDeep(this.form);
  }

  public async validateBeforeSubmit() {
    if (!this.$webhookData.canUpdate) return;

    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$webhookMethods.updateWebhook(this.formValues);
      await this.$webhookMethods.reloadData();
      this.initiateForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.webhooks.webhook_successfully_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.form = this.$_.cloneDeep(this.initialForm);
  }

  // Computed

  public get formIsDisabled() {
    return !this.$webhookData.canUpdate || this.isProcessing;
  }

  public get isFormChanged() {
    return !_.isEqual(this.form, this.initialForm);
  }

  public get formValues() {
    return _.omitBy(this.form, (v, k) => {
      return this.initialForm[k] === v;
    });
  }
}
